import { render, staticRenderFns } from "./RationsTable.vue?vue&type=template&id=fa81a4d2&lang=pug"
import script from "./RationsTable.vue?vue&type=script&lang=js"
export * from "./RationsTable.vue?vue&type=script&lang=js"
import style0 from "./RationsTable.vue?vue&type=style&index=0&id=fa81a4d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports